import * as actions from './paymentMode/actions'
import * as mutations from './paymentMode/mutations'
import * as getters from './paymentMode/getters'

import { dataProps } from './paymentMode/properties'

const state = {
    list: [],
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/paymentMode.js